// extracted by mini-css-extract-plugin
export var container = "MenuCart-module--container--3LVBd";
export var notification = "MenuCart-module--notification--31bGY";